import { AttachedCommunication } from "@/Common/Models/AttachedCommunication/AttachedCommunication";
import { TaskStatus } from "@/Common/Resources/Lookups/Enums/CommonLookupCodes";

class PopulationBasedFundingEventTask extends AttachedCommunication {
    public IsComplete: boolean;

    constructor(init: AttachedCommunication) {
        super();
        Object.assign(this, init);
        this.IsComplete = cacheStore.FindLookupByLookupCode(TaskStatus.Completed, TaskStatus.Code)?.LookupID == this.StatusId;
    }
}

export { PopulationBasedFundingEventTask };
